import { useState } from "react";
import styled from "styled-components";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledInput = styled.input`
  font-family: "Open Sans", sans-serif;
  width: 100%;
  padding: 0.625rem;
  padding-right: 2.5rem;           // ~40px
  margin: 0.625rem 0;
  border: 1px solid #ccc;
  border-radius: 0.3125rem;
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: #076633;
  }
`;

const ToggleButton = styled.button`
  position: absolute;
  right: 0.625rem;                // ~10px
  background: none;
  border: none;
  cursor: pointer;
`;

export const InputSenha = ({ value, onChange, placeholder }) => {
    const [mostrar, setMostrar] = useState(false);

    return (
        <Container>
            <StyledInput
                type={mostrar ? "text" : "password"}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
            />
            <ToggleButton type="button" onClick={() => setMostrar(!mostrar)}>
                {mostrar ? <FaRegEyeSlash /> : <FaRegEye />}
            </ToggleButton>
        </Container>
    );
};
